import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pinIcon = L.divIcon({
  className: "",
  html: '<div style="width:18px;height:18px;border-radius:50%;background:#16a34a;border:3px solid #fff;box-shadow:0 0 0 1px rgba(0,0,0,.25)"></div>',
  iconSize: [18, 18], iconAnchor: [9, 9],
});

function ClickCapture({ onSet }) {
  useMapEvents({ click(e) { onSet(e.latlng.lat, e.latlng.lng); } });
  return null;
}

export default function PinPicker({ lat, lng, onSet }) {
  const has = lat != null && lng != null;
  const center = has ? [lat, lng] : [45.54, 10.22];
  return (
    <div className="h-52 w-full overflow-hidden rounded-md border border-input" data-testid="pin-picker">
      <MapContainer center={center} zoom={has ? 13 : 6} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
        <ClickCapture onSet={onSet} />
        {has && (
          <Marker position={[lat, lng]} icon={pinIcon} draggable
            eventHandlers={{ dragend: (e) => { const ll = e.target.getLatLng(); onSet(ll.lat, ll.lng); } }} />
        )}
      </MapContainer>
    </div>
  );
}
